import { MasonryEngineNodeRendererMap } from '@leagueplatform/masonry-engine';
import {
  MasonryCarouselRenderer,
  MasonryColumnLayoutRenderer,
  MasonryCTACardRenderer,
  MasonryDriverNode,
  MasonryHeroBannerRenderer,
  MasonryImageBannerRenderer,
  MasonryLargeCardRenderer,
  MasonryMetricCardRenderer,
  MasonryNotificationBannerRenderer,
  MasonryNotificationCardRenderer,
  MasonryProgressBarCardRenderer,
  MasonryProgressRingCardRenderer,
  MasonrySectionHeaderRenderer,
  MasonrySmallCardRenderer,
  MasonryMicroCardRenderer,
  MasonryExtraSmallCardRenderer,
  MasonryVerticalLayoutRenderer,
  MasonryHorizontalLayoutRenderer,
  MasonryGridLayoutRenderer,
  MasonryLoaderRenderer,
  MasonryTabsRenderer,
  MasonrySidebarLayoutRenderer,
  MasonryTextActionRenderer,
  MasonryButtonRenderer,
  MasonryFormRenderer,
  MasonryVideoRenderer,
  MasonryStatusBannerRenderer,
  MasonryTextInputRenderer,
  MasonryContentBlockRenderer,
  MasonryAccordionItemRenderer,
  MasonrySelectInputRenderer,
  MasonryStickyLayoutRenderer,
  MasonryCheckboxRenderer,
  MasonryRadioRenderer,
  MasonrySegmentControlRenderer,
  MasonryBasicTableRenderer,
  MasonryDividerRenderer,
  MasonryComposableCardRenderer,
  MasonryPageHeaderRenderer,
  MasonryHeadingTextRenderer,
  MasonryFlowStepRenderer,
  MasonryFlowNodeRenderer,
  MasonryBoxNodeRenderer,
} from '@leagueplatform/masonry-renderers';
import {
  MasonrySpinner,
  MasonrySpinnerNode,
} from '#components/spinner/spinner.component.tsx';

export const MasonryDriverDefaultNodeRendererMap: MasonryEngineNodeRendererMap<
  MasonryDriverNode | MasonrySpinnerNode
> = {
  carousel: MasonryCarouselRenderer,
  // @TODO fix naming of column layout type
  column_layout: MasonryColumnLayoutRenderer,
  containerSpinner: MasonrySpinner,
  contentBlock: MasonryContentBlockRenderer,
  ctaCard: MasonryCTACardRenderer,
  extraSmallCard: MasonryExtraSmallCardRenderer,
  composableCard: MasonryComposableCardRenderer,
  pageHeader: MasonryPageHeaderRenderer,
  form: MasonryFormRenderer,
  gridLayout: MasonryGridLayoutRenderer,
  heroBanner: MasonryHeroBannerRenderer,
  hidden: () => null,
  headingText: MasonryHeadingTextRenderer,
  horizontalLayout: MasonryHorizontalLayoutRenderer,
  imageBanner: MasonryImageBannerRenderer,
  largeCard: MasonryLargeCardRenderer,
  loader: MasonryLoaderRenderer,
  metricCard: MasonryMetricCardRenderer,
  microCard: MasonryMicroCardRenderer,
  notificationBanner: MasonryNotificationBannerRenderer,
  notificationCard: MasonryNotificationCardRenderer,
  progressBar: MasonryProgressBarCardRenderer,
  progressRing: MasonryProgressRingCardRenderer,
  sectionHeader: MasonrySectionHeaderRenderer,
  sidebarLayout: MasonrySidebarLayoutRenderer,
  smallCard: MasonrySmallCardRenderer,
  statusBanner: MasonryStatusBannerRenderer,
  stickyLayout: MasonryStickyLayoutRenderer,
  tabs: MasonryTabsRenderer,
  textAction: MasonryTextActionRenderer,
  verticalLayout: MasonryVerticalLayoutRenderer,
  video: MasonryVideoRenderer,
  accordionItem: MasonryAccordionItemRenderer,
  basicTable: MasonryBasicTableRenderer,
  divider: MasonryDividerRenderer,
  // form renderers
  selectInput: MasonrySelectInputRenderer,
  textInput: MasonryTextInputRenderer,
  button: MasonryButtonRenderer,
  checkboxGroup: MasonryCheckboxRenderer,
  radioGroup: MasonryRadioRenderer,
  segmentedControl: MasonrySegmentControlRenderer,
  linearFlowStep: MasonryFlowStepRenderer,
  linearFlow: MasonryFlowNodeRenderer,
  box: MasonryBoxNodeRenderer,
};

export type MasonryDriverDefaultNodeType =
  keyof typeof MasonryDriverDefaultNodeRendererMap;
